// extracted by mini-css-extract-plugin
export default {"info":"src-components-molecule-dataView-dataView-module__info--SGvZR"};